import { IMG_ALI, IMG_SHAHADA, IMG_SHINI } from "../assets/images";

export const TEAM = [
  {
    img: IMG_ALI,
    badge: "CEO",
    name: "ALI AL ALI",
    role: "Chief Executive Officer",
    email: "ali@middleeastblackcarbon.ca",
    bio: "Founding CEO with over 20 years of experience in industrial operations, mining, and tire pyrolysis. Leads company strategy, production oversight, and business development for rCB supply operations.",
    tags: ["20+ Yrs Industry", "Pyrolysis", "Mining"],
  },
  {
    img: IMG_SHAHADA,
    badge: "MD",
    name: "SALEH SHAHADA",
    role: "Managing Director",
    email: "salehshahada@middleeastblackcarbon.ca",
    bio: "Managing Director with over 20 years of experience in industrial management, materials recycling, and renewable energy applications. Oversees operational execution, administrative coordination, and recovered material integration.",
    tags: ["20+ Yrs Mgmt", "Recycling", "Renewables"],
  },
  {
    img: IMG_SHINI,
    badge: "OCM",
    name: "SALEH SHINI",
    role: "Operations & Commercial Manager",
    email: "salehshini@middleeastblackcarbon.ca",
    location: "Canada",
    bio: "Based in Canada, manages international commercial communication, buyer coordination, and technical discussions. Background in industrial operations, electrical systems, maintenance, and recycling-related thermal processing. Primary international contact between buyers and production.",
    tags: ["Canada", "Industrial Ops", "Commercial"],
  },
];
